
import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "CircularImage",
  props: {
    image: {
      type: String,
      required: true
    },
    alt: {
      type: String
    },
    position: {
      type: Number,
      required: true
    }
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "60c13903": (_ctx.image)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__